import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faDragon,
  faDice,
  faChartBar
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../state/Store';
import { ToggleMenu } from '../../layout/actions/Layout.actions';

export const EtheriaMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/etheria-restart/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/etheria-restart/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/etheria-restart/characters-stats">
        <Nav.Link as="span" eventKey="characters-stats" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faChartBar} width="18" />{' '}
          <span>Characters Stats</span>
        </Nav.Link>
      </Link>
      <Link to="/etheria-restart/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/etheria-restart/shells">
        <Nav.Link as="span" eventKey="shells" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faDragon} width="18" /> <span>Shells</span>
        </Nav.Link>
      </Link>
      <Link to="/etheria-restart/matrix-effects">
        <Nav.Link as="span" eventKey="matrix" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faDice} width="18" />{' '}
          <span>Matrix Effects</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/etheria-restart/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/etheria-restart/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
    </Nav>
  );
};
